import React from 'react';

const QuickReplies = ({ items = [], onSelect, disabled = false }) => {
  if (!items.length) return null;

  return (
    <div className="edugenie-chips" role="group" aria-label="Quick replies">
      {items.map((item) => {
        const label = typeof item === 'string' ? item : (item.label || item.message_text || '');
        const message = typeof item === 'string'
          ? item
          : (item.message_text || item.label || '');
        const intentCode = typeof item === 'string' ? null : (item.intent_code || null);
        const key = typeof item === 'string' ? item : (item.action_code || item.id || label);

        return (
          <button
            key={key}
            type="button"
            className="edugenie-chip"
            disabled={disabled}
            onClick={() => onSelect({ message, intentCode })}
            aria-label={`Send quick reply: ${label}`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default QuickReplies;
